/* Atterrissage post-authentification (doctrine Agentique) :
 * experience_mode = agentic → /app/noam systématiquement (porte d'entrée NOAM).
 * expert → comportement historique (fallback fourni par l'appelant). */
import { api } from "@/lib/api";

export async function resolvePostLoginTarget(fallback) {
  try {
    const r = await api.get("/workspace/agentic/mode", { timeout: 4000 });
    if (r.data?.mode === "agentic") return "/app/noam";
  } catch {
    /* endpoint indisponible ou lent (timeout 4s) → comportement historique */
  }
  return fallback;
}
